import React, { useState, useContext, useRef } from "react";
import { Button, Link, CssBaseline, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { userServices } from "../services";
import { Toast, Loader, TextField } from "../components";
import { AuthContext } from "../context";
import { InfoCircleIcon } from "../icons";

import { validarRUT } from "validar-rut";

// [CAPTCHA] import ReCAPTCHA from "react-google-recaptcha";

export default function Auth() {
  const classes = useStyles();
  const history = useHistory();
  const { register, handleSubmit, errors } = useForm();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { signIn } = useContext(AuthContext);

  // [CAPTCHA]
  // const [isCaptchaVisible, setIsCaptchaVisible] = useState(false);
  // const [disableLoginButton, setDisableLoginButton] = useState(false);
  // const captchaRef = useRef(null);

  // const captchaOnChange = () => {
  //   if (captchaRef.current.getValue()) {
  //     setDisableLoginButton(false);
  //   }
  // };

  const login = async (data) => {
    if (validarRUT(data.username)) {
      setToast(true);
      setToastMessage("Acceso no autorizado");
      return;
    }
    try {
      setLoading(true);
      const { status, response } = await userServices.loginUser({
        email: data.username,
        password: data.password,
      });
      setLoading(false);
      if (status === 200) {
        if (response.user) {
          const userObj = response.user || response.data?.user;

          // Robust extraction: Check root level AND inside user object
          const accessToken = response.accessToken || response.token || response.data?.accessToken || response.data?.token || userObj?.accessToken || userObj?.token;
          const refreshToken = response.refreshToken || response.refresh_token || response.data?.refreshToken || response.data?.refresh_token || userObj?.refreshToken || userObj?.refresh_token; 
          
          const user = userObj;

          if (!accessToken || !refreshToken) {
             setToast(true);
             setToastMessage("Error: No se recibieron los tokens de autenticación.");
             setLoading(false);
             return;
          }
          
          signIn({ 
            user: user, 
            token: accessToken, 
            refreshToken: refreshToken 
          });
          history.push("/");
        } else {
          setToast(true);
          setToastMessage(response.error.message);

          // [CAPTCHA] captchaRef.current?.reset();
          // [CAPTCHA] setIsCaptchaVisible(true);
          // [CAPTCHA] setDisableLoginButton(true);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onKeyDownHandler = (e) => {
    if (e.keyCode === 13) {
    }
  };

  return (
    <Grid container alignItems="flex-end">
      {loading && <Loader loading={true} />}
      <Toast
        open={toast}
        message={toastMessage}
        close={() => setToast(false)}
      />
      <Container className={classes.container} component="main" maxWidth="md">
        <CssBaseline />
        <Grid
          container
          style={{ padding: "45px 0 52px" }}
          justify="center"
          alignItems="center"
        >
          <img src="../../Unio-01.png" alt="" style={{ width: 150 }} />
        </Grid>
        <Grid
          container
          direction="column"
          alignItems="center"
          justify="center"
          className={classes.paper}
        >
          <Grid container spacing={3} justify="center">
            <Grid item md={12} xs={12}>
              <Typography className={classes.title} align="center">
                Inicio de sesión
              </Typography>
            </Grid>
            <form
              className={classes.form}
              noValidate
              onSubmit={handleSubmit(login)}
              onKeyDown={onKeyDownHandler}
            >
              <Grid container spacing={2} justify="center">
                <Grid item md={6} xs={12}>
                  <TextField
                    name="username"
                    autoComplete="username"
                    placeholder="Nombre de usuario *"
                    onKeyPress={() => {}}
                    inputRef={register({
                      required: "Nombre de usuario requerido",
                    })}
                    error={errors.rut && errors.rut.isInvalid}
                    helperText={errors.rut ? errors.rut.message : ""}
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <TextField
                    name="password"
                    type={"password"}
                    placeholder="Contraseña *"
                    style={{ justifyContent: "flex-end" }}
                    error={errors.password && errors.password.isInvalid}
                    inputRef={register({ required: "Contraseña requerida" })}
                    helperText={errors.password ? errors.password.message : ""}
                  />
                  <Link
                    href="account/reset-password"
                    style={{ cursor: "pointer" }}
                  >
                    <Typography className={classes.colorText} color="secondary">
                      <InfoCircleIcon style={{ margin: "0 5px 0 0" }} />{" "}
                      Recuperar contraseña
                    </Typography>{" "}
                  </Link>
                </Grid>

                {/* [CAPTCHA]
                {isCaptchaVisible && (
                  <Grid item md={8} xs={12} container justify="center">
                    <ReCAPTCHA
                      ref={captchaRef}
                      sitekey="6Lcz_FkrAAAAAO9wXBX9Ft6ls16EaYzC6hKhwCBr"
                      onChange={captchaOnChange}
                    />
                  </Grid>
                )}
                */}

                <Grid item md={6} xs={12}>
                  <Button
                    fullWidth
                    type="submit"
                    className={classes.button}
                    disabled={false} /* [CAPTCHA] disabled={disableLoginButton} */
                  >
                    Iniciar sesión
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    overflowY: "scroll",
    height: "100vh",
    [theme.breakpoints.up("md")]: {
      overflowY: "unset",
    },
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
  },
  title: {
    fontSize: "1.125rem",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    margin: 0,
  },
  paper: {
    boxSizing: "border-box",
    borderRadius: "45px 45px 0 0",
    boxShadow: "0px -3px 5px #D6D6D6BF",
    [theme.breakpoints.down("xs")]: {
      padding: 25,
    },
    [theme.breakpoints.up("md")]: {
      boxShadow: "unset",
    },
  },
  colorText: {
    fontWeight: "500",
    fontSize: "0.75rem",
    lineHeight: "0.914rem",
    letterSpacing: "0.05em",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    margin: "20px 0 0 0",
  },
  button: {
    backgroundColor: theme.palette.secondary.main,
    fontSize: "1.313rem",
    lineHeight: "1.508rem",
    letterSpacing: " 0.05em",
    color: "#FFFFFF",
    borderRadius: 30,
    fontWeight: "700",
    height: 40,
    [theme.breakpoints.up("md")]: {
      fontSize: "1.125rem",
      lineHeight: "1.375rem",
    },
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
    [theme.breakpoints.down("xs")]: {
      height: 41,
      fontSize: "1.125rem",
      lineHeight: "1.371rem",
    },
  },
}));
